/* Five Origins — eticheta in romana pentru blocul aplicatiei Subscriptions.
   Aplicatia nu expune aceste texte nicaieri in admin: trei sunt nume de plan,
   trei sunt siruri proprii ale aplicatiei. Le inlocuim dupa randare.
   Daca aplicatia isi schimba markup-ul, textul ramane in engleza — nu se strica nimic. */
(function () {
  'use strict';

  var RO = {
    'One-time purchase': 'O singură dată',
    'Subscription': 'Abonament',
    'Deliver every month, 15% off': 'Lunar — 15% reducere',
    'Deliver every 2 weeks, 15% off': 'La 2 săptămâni — 15% reducere',
    'Deliver every week, 15% off': 'Săptămânal — 15% reducere',
    'Auto-renews, skip or cancel anytime.': 'Se reînnoiește automat. Poți sări o livrare sau anula oricând.'
  };

  var SEL = '[id*="subscriptions_app_block"]';
  var busy = false;

  function translate(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue.trim();
      if (text && RO[text]) node.nodeValue = node.nodeValue.replace(text, RO[text]);
    }
  }

  function run() {
    if (busy) return;
    busy = true;
    try {
      var blocks = document.querySelectorAll(SEL);
      for (var i = 0; i < blocks.length; i++) translate(blocks[i]);
    } finally {
      busy = false;
    }
  }

  function boot() {
    run();
    if (!document.body) return;
    new MutationObserver(function () {
      window.requestAnimationFrame(run);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', run);
})();
